import _ from "underscore";

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ClassNames from 'classnames';
import Slider from './Slider';

class VolumeControl extends Component {
  constructor() {
    super();
    _.bindAll(this,
      'toggleMute',
      'shiftVolumeLevel',
      '_effectiveVolumeLevel'
    );
  }

  toggleMute() {
    this.props.toggleMute();
  }

  shiftVolumeLevel(volumeLevel) {
    this.props.shiftVolumeLevel(volumeLevel);
  }

  _volumeIcon() {
    let volumeIcon;

    if (this.props.volumeLevel === 0 || this.props.mute) {
      volumeIcon = 'volume_off';
    } else if (this.props.volumeLevel < 0.5) {
      volumeIcon = 'volume_down';
    } else {
      volumeIcon = 'volume_up';
    }

    return volumeIcon;
  }

  _effectiveVolumeLevel() {
    return this.props.mute ? 0 : this.props.volumeLevel;
  }

  render() {
    return (
      <div className="browser-audio-volume-control">
        <div className="browser-audio-volume-button" onClick={this.toggleMute}>
          <i className={ClassNames('browser-audio-volume-icon', 'material-icons')} aria-hidden="true">{this._volumeIcon()}</i>
        </div>

        <div className="browser-audio-volume">
          <Slider pixelLength={50} percentComplete={this._effectiveVolumeLevel()} shiftPercentComplete={this.shiftVolumeLevel}/>
        </div>
      </div>
    );
  }
}

VolumeControl.propTypes = {
  volumeLevel: PropTypes.number.isRequired,
  mute: PropTypes.bool.isRequired,
  toggleMute: PropTypes.func.isRequired,
  shiftVolumeLevel: PropTypes.func.isRequired
};

export default VolumeControl;
